import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { FeatureFlagService } from './_flags/feature-flag.service';
import { FLAG_PRUEBA_UNLEASH } from './_flags/feature-flag.model';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'CotizacionSPA';
  loading: boolean = false;
  constructor(
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private flags: FeatureFlagService
  ) {
    this.router.events.forEach(item => {

      if (item instanceof NavigationEnd) {

        const gtmTag = {
          event: 'page',
          pageName: item.url
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
    //this.sessionService.reset();
  }

  public ngOnInit() {
    localStorage.removeItem('FiltrosCzDescartadas');
    localStorage.removeItem('FiltrosCz');

    // Prueba de la integración con Unleash: solo informa, no cambia nada en pantalla.
    this.flags.listo().then(() => {
      const estado = this.flags.isEnabled(FLAG_PRUEBA_UNLEASH) ? 'ON' : 'OFF';
      console.info(`[flags] ${FLAG_PRUEBA_UNLEASH}: ${estado} (fuente: ${this.flags.fuente()})`);
    });
  }

  public ngOnDestroy() {

  }

}
